import {createContext} from "react";

export interface KhanmigoSidebarState {
    /**
     * Whether or not Khanmigo is rendered in "companion mode".
     * This is false when loaded in a standalone experience like an AI activity
     */
    isCompanionMode: boolean;
}

const defaultState: KhanmigoSidebarState = {
    isCompanionMode: false,
};

export const KhanmigoSidebarContext =
    createContext<KhanmigoSidebarState>(defaultState);
